// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3ArYF","detailsBorder":"styles_detailsBorder__1EuXE"};